import { createSelector } from "reselect";

const notification = (state) => state.notification.item;

export const getNotification = createSelector(
    notification,
    (notification) => {
        return Object.keys(notification).length ? notification : null;
    }
);
